import React from 'react';
import { ArticleBreadcrumbs } from '../../../../components/ArticleBreadcrumbs';
import { ArticleCoverPhoto } from '../../../../components/ArticleCoverPhoto/v2';
import { ArticleShareIcons } from '../../../../components/ArticleShareIcons';
import { ArticleTitle } from '../../../../components/ArticleTitle';
import { TrainingGuideInfo } from '../TrainingGuideInfo';
import { Camelize } from '../../../../types/camelize';
import { ShareUrl, ArticleReadTime } from '../../../../types/api/article';
import { Breadcrumb } from '../../../../wag-react/components/Breadcrumbs';
import { theme } from '../../../../wag-react/themes/base-theme';
import { Box } from '../../../../wag-react/next-components/box';
export type TrainingHeaderProps = {
  breadcrumbs: Breadcrumb[];
  heroImageUrl: string;
  numQuestionsStories: number;
  shareUrls: ShareUrl[];
  title: string;
  readTime: Camelize<ArticleReadTime>;
};
export const TrainingHeader = ({
  breadcrumbs,
  heroImageUrl,
  numQuestionsStories,
  shareUrls,
  title,
  readTime
}: TrainingHeaderProps) => <Box as="header" data-sentry-element="Box" data-sentry-component="TrainingHeader" data-sentry-source-file="index.tsx">
    <ArticleBreadcrumbs value={breadcrumbs} px={['16px', 'unset']} data-sentry-element="ArticleBreadcrumbs" data-sentry-source-file="index.tsx" />

    {/* Mobile only */}
    <TrainingGuideInfo display={['grid', 'none']} numQuestionsStories={numQuestionsStories} readTime={readTime.text} px={['16px', 'unset']} data-sentry-element="TrainingGuideInfo" data-sentry-source-file="index.tsx" />

    <ArticleTitle color={theme.colors.charcoal} mt={['unset', '40px']} mb="8px" px={['16px', 'unset']} data-sentry-element="ArticleTitle" data-sentry-source-file="index.tsx">
      {title}
    </ArticleTitle>

    <ArticleShareIcons as="div" display={['block', 'none']} value={shareUrls} title={title} position="initial" mb={['16px', 'unset']} containerProps={{
    position: 'initial',
    gridTemplateColumns: 'repeat(auto-fill, 64px)',
    gridGap: 0
  }} data-sentry-element="ArticleShareIcons" data-sentry-source-file="index.tsx" />

    {/* Tablet / Desktop only */}
    <TrainingGuideInfo display={['none', 'grid']} numQuestionsStories={numQuestionsStories} readTime={readTime.text} data-sentry-element="TrainingGuideInfo" data-sentry-source-file="index.tsx" />

    <ArticleCoverPhoto alt={title} src={`${heroImageUrl}?auto=compress&w=768&h=432`} title={title} borderRadius={['none', '8px']} mb={[0, '10px']} data-sentry-element="ArticleCoverPhoto" data-sentry-source-file="index.tsx" />
  </Box>;